import { Box } from '@mui/material'

import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { BodyText } from '@/components/atoms/BodyText'
import { FONT_WEIGHT, UI_FONT_SIZE } from '@/shared/styles/typography'

interface Props {
  // 録音中 sequential update が毎周期上書きする「今確認すべきこと」の current state。
  // 先頭 1 件だけを表示する (= 一覧化せず最優先の 1 点に絞る)。
  recommendations: string[]
}

// ハイライトタブ最下部に sticky で固定する「今確認すること」。 scroll の影響を受けず常に
// 1 行で見える。 bullet 一覧で場所を取らず、 muted ラベル + 本文の 1 行に洗練する (Notion 流)。
// recommendations が空なら何も出さない (= 録音中の無駄な存在感を出さない)。
export const InterventionRecommendations = ({ recommendations }: Props) => {
  const top = recommendations[0]
  if (!top) return null
  return (
    <Box
      sx={{
        flexShrink: 0,
        display: 'flex',
        alignItems: 'baseline',
        gap: 1,
        px: 2,
        py: 1.25,
        borderTop: `1px solid ${colorTokens.border.default}`,
      }}
    >
      <Box
        component="span"
        sx={{
          flexShrink: 0,
          fontSize: UI_FONT_SIZE.micro,
          fontWeight: FONT_WEIGHT.medium,
          color: colorTokens.fg.faint,
        }}
      >
        今確認すること
      </Box>
      <BodyText sx={{ flex: 1, minWidth: 0 }}>{top}</BodyText>
    </Box>
  )
}
